<template>
<div class="content">
  <div class="header">
    <div style="margin-bottom: 10px">
      <!--    <el-button v-if="urge_type!==1" type="primary" size="mini" @click="exportExcelNote()">导出房产</el-button>-->
      <el-button-group>
        <!--      <el-button type="primary" size="mini" @click="toThirdPartyLitigations(1)">自催</el-button>-->
        <el-button type="primary" size="mini" v-if="show_btn_type.includes(2)&&urge_type!==2" @click="toThirdPartyLitigations(2)">项目诉讼</el-button>
        <el-button type="primary" size="mini" v-if="show_btn_type.includes(5)&&urge_type!==5" @click="toThirdPartyLitigations(5)">项目自催</el-button>
        <el-button type="primary" size="mini" v-if="show_btn_type.includes(3)&&urge_type!==3" @click="toThirdPartyLitigations(3)">第三方管理</el-button>
        <el-button type="primary" size="mini" v-if="show_btn_type.includes(4)&&urge_type!==4" @click="toThirdPartyLitigations(4)">第三方诉讼</el-button>
      </el-button-group>
<!--      <el-button size="mini" v-if="ERP.isPermission(8007001007)" @click="exportExcel(2)">导出计划催费房产</el-button>-->
<!--      <el-button size="mini" v-if="[3,4].includes(urge_type)" @click="exportThirdPartyExcel()">导出第三方填报表</el-button>-->
    </div>
    <div style="margin-bottom: 10px">
      <el-select size="mini" placeholder="账龄类型" clearable v-model="reginWhere.age" v-if="!header_not_search.includes('p_age')">
        <el-option :value="1" label="当期" v-if="urge_type===1"></el-option>
        <el-option :value="2" label="纯上一年" v-if="urge_type===1"></el-option>
        <el-option :value="3" label="一年以上两年以内" v-if="urge_type!==1"></el-option>
        <el-option :value="4" label="两年以上" v-if="urge_type!==1"></el-option>
<!--        <el-option :value="5" label="1年以上" v-if="urge_type!==1"></el-option>-->
      </el-select>
      <el-select size="mini" placeholder="账龄类型" clearable v-model="where2.age" v-if="!header_not_search.includes('age')">
        <el-option :value="1" label="当期" v-if="urge_type===1"></el-option>
        <el-option :value="2" label="纯上一年" v-if="urge_type===1"></el-option>
        <el-option :value="3" label="一年以上两年以内" v-if="urge_type!==1"></el-option>
        <el-option :value="4" label="两年以上" v-if="urge_type!==1"></el-option>
<!--        <el-option :value="5" label="1年以上" v-if="urge_type!==1"></el-option>-->
      </el-select>
      <el-date-picker
        style="width: 120px"
        v-model="where2.jh_time"
        size="mini"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM" placeholder="计划催费月份" v-if="!header_not_search.includes('jh_time')">
      </el-date-picker>
      <!--    <el-date-picker-->
      <!--      style="width: 120px"-->
      <!--      v-model="where2.qf_time"-->
      <!--      size="mini"-->
      <!--      type="month"-->
      <!--      format="yyyy-MM"-->
      <!--      value-format="yyyy-MM" placeholder="欠费月份">-->
      <!--    </el-date-picker>-->
      <el-date-picker
        style="width: 150px"
        v-model="where2.gj_time"
        size="mini"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd" placeholder="跟进日期" v-if="!header_not_search.includes('gj_time')">
      </el-date-picker>
<!--      <el-select size="mini" placeholder="是否催费" clearable v-model="where2.is_use" v-if="!header_not_search.includes('is_use')">-->
<!--        <el-option :value="0" label="全部"></el-option>-->
<!--        <el-option :value="1" label="已催费"></el-option>-->
<!--        <el-option :value="2" label="待催费"></el-option>-->
<!--      </el-select>-->
      <!--    <el-select size="mini" placeholder="催费次数" clearable v-model="where2.type">-->
      <!--      <el-option :value="0" label="暂未催费"></el-option>-->
      <!--      <el-option :value="1" label="1次催费"></el-option>-->
      <!--      <el-option :value="2" label="2次催费"></el-option>-->
      <!--      <el-option :value="3" label="3次催费"></el-option>-->
      <!--      <el-option :value="4" label="多次催费"></el-option>-->
      <!--    </el-select>-->
      <el-input clearable placeholder="欠费月数" v-model="where2.month_count" style="width: 100px" size="mini" v-if="!header_not_search.includes('month_count')"></el-input>
      <el-select size="mini" placeholder="月催费次数" clearable v-model="where2.cur_month_times" style="width: 120px;" v-if="!header_not_search.includes('cur_month_times')">
        <el-option :value="0" label="暂未催费"></el-option>
        <el-option :value="1" label="1次催费"></el-option>
        <el-option :value="2" label="2次催费"></el-option>
        <el-option :value="3" label="3次催费"></el-option>
        <el-option :value="4" label="多次催费"></el-option>
      </el-select>
      <el-select size="mini" placeholder="年催费次数" clearable v-model="where2.cur_year_times" style="width: 120px;" v-if="!header_not_search.includes('cur_year_times')">
        <el-option :value="0" label="暂未催费"></el-option>
        <el-option :value="1" label="1次催费"></el-option>
        <el-option :value="2" label="2次催费"></el-option>
        <el-option :value="3" label="3次催费"></el-option>
        <el-option :value="4" label="多次催费"></el-option>
      </el-select>
      <el-select size="mini" placeholder="选择房态" clearable v-model="where2.room_status" style="width: 120px;" v-if="!header_not_search.includes('room_status')">
        <el-option :value="1" label="空置"></el-option>
        <el-option :value="2" label="未领"></el-option>
        <el-option :value="3" label="空关"></el-option>
        <el-option :value="4" label="装修"></el-option>
        <el-option :value="5" label="入住"></el-option>
        <el-option :value="6" label="出租"></el-option>
        <el-option :value="7" label="停用"></el-option>
      </el-select>
      <el-select size="mini" placeholder="欠费类型" clearable v-model="where2.arrears_level1" style="width: 180px;" @change="changeArrearsLevel1" v-if="!header_not_search.includes('arrears_level1')">
        <el-option v-for="(item, index) in arrears_arr" :key="index" :value="item.id" :label="item.name"></el-option>
      </el-select>
      <el-select size="mini" placeholder="欠费类型-原因" clearable v-model="where2.arrears_level2" style="width: 180px;" v-if="!header_not_search.includes('arrears_level2')">
        <el-option v-for="(item, index) in arrears_arr_children" :key="index" :value="item.id" :label="item.name"></el-option>
      </el-select>
      <el-input clearable placeholder="输入房产" v-model="where2.house_name" style="width: 200px" size="mini" v-if="!header_not_search.includes('house_name')"></el-input>
    </div>
  </div>
  <div class="header" style="margin-top: 10px;justify-content: flex-end">
<!--    <el-button type="danger" size="mini" @click="delHouseIds()">批量移除</el-button>-->
<!--    <el-button type="primary" size="mini" @click="houseLegalToTempByHouseIds()">批量添加</el-button>-->
<!--    <el-button type="primary" size="mini" @click="houseLegalToTemp()">全部添加</el-button>-->
<!--    <el-button size="mini" @click="exportExcel(1)">导出房产（所有房产）</el-button>-->
<!--    <el-button size="mini" @click="exportExcel(2)">导出房产（催缴房产）</el-button>-->
<!--    <el-button size="mini" @click="importLegalHouseExcel">导入催缴房产</el-button>-->
  </div>
  <header-tip>
    催缴房产数量： {{pageData.total}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </header-tip>
  <header-tip v-if="legalHouseCountObj.use_yaer_count>0">
    年度已催房产：{{legalHouseCountObj.use_yaer_count}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    年度催缴房产覆盖率：{{useYaerRate}} %&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    月度已催房产：{{legalHouseCountObj.use_month_count}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    月度催缴房产覆盖率：{{useMonthRate}} %&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </header-tip>
  <AgeTip
    v-if="showAge"
    :project_id="reginWhere.project_name"
    :project_ids="reginWhere.project_ids"
    :ages="ages"
    :yearmonth="where2.jh_time"
  ></AgeTip>
<!--  <AgeTip-->
<!--    v-if="!header_not_search.includes('p_age')&&reginWhere.age"-->
<!--    :project_id="reginWhere.project_name"-->
<!--    :project_ids="reginWhere.project_ids"-->
<!--    :ages="ages2"-->
<!--    :yearmonth="where2.jh_time"-->
<!--  >-->
<!--    <span slot="start">-->
<!--      催费房产数：{{pageData.total}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--    </span>-->
<!--    <template slot="item" slot-scope="sc">-->

<!--    </template>-->
<!--  </AgeTip>-->

  <div class="body">
    <div>
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          border
          style="width: 100%" height="60vh" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45" fixed v-if="urge_type!==1"></el-table-column>
          <el-table-column
            prop="房产信息"
            label="房产信息" width="320" fixed></el-table-column>
          <el-table-column
            prop="区域"
            label="区域"
            width="90">
          </el-table-column>
          <el-table-column
            prop="业主"
            label="业主姓名"
            width="100">
          </el-table-column>
          <el-table-column
            prop="业主电话"
            label="业主电话"
            width="150">
          </el-table-column>
          <el-table-column
            prop="房态"
            label="房态"
            width="100">
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="是否催费"-->
<!--            label="是否催费"-->
<!--            width="100">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="催缴次数"-->
<!--            label="催缴次数"-->
<!--            width="100">-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--            label="银行划扣"-->
<!--            width="90">-->
<!--            <template slot-scope="scope">-->
<!--              <span style="color: #328628" v-if="scope.row.bankType">是</span>-->
<!--              <span v-if="!scope.row.bankType"></span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            prop="欠费起始月份"
            label="欠费起始月份"
            width="120">
          </el-table-column>
          <el-table-column
            prop="欠费月数"
            label="欠费月数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="欠费金额/诉讼金额"
            label="欠费金额/诉讼金额"
            width="140">
            <template slot-scope="scope">
              <el-link v-if="scope.row['催缴类型']!=='诉讼'" type="primary" size="mini" @click="getHouseBill(scope.row)">{{ formatMoney(scope.row['欠费金额'],2) }}</el-link>
              <span v-if="scope.row['催缴类型']==='诉讼'">{{formatMoney(scope.row['诉讼金额'],2)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="计划催缴月份"
            label="计划催缴月份"
            width="150">
<!--            <template slot-scope="scope">-->
<!--              <el-date-picker-->
<!--                style="width: 100%"-->
<!--                v-model="scope.row['计划催缴月份']"-->
<!--                size="mini"-->
<!--                type="month"-->
<!--                format="yyyy-MM"-->
<!--                value-format="yyyy-MM" placeholder="计划催缴月份">-->
<!--              </el-date-picker>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column
            prop="催缴类型"
            label="催缴类型"
            width="150">
<!--            <template slot-scope="scope">-->
<!--              <el-select v-model="scope.row['催缴类型']" size="mini" placeholder="请选择" style="width: 100%">-->
<!--                <el-option value="" label="&#45;&#45;"></el-option>-->
<!--                <el-option value="诉讼" label="项目诉讼"></el-option>-->
<!--                <el-option value="项目自催" label="项目自催"></el-option>-->
<!--                <el-option value="第三方管理" label="第三方管理"></el-option>-->
<!--                <el-option value="第三方诉讼" label="第三方诉讼"></el-option>-->
<!--              </el-select>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column
            prop="诉讼金额"
            label="诉讼金额"
            width="150">
<!--            <template slot-scope="scope">-->
<!--              <el-input v-model="scope.row['诉讼金额']" size="mini" placeholder="请输入诉讼金额"></el-input>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column
            prop="第三方合作单位"
            label="第三方合作单位"
            width="200">
<!--            <template slot-scope="scope">-->
<!--              <el-select v-model="scope.row['第三方合作单位']" size="mini" placeholder="请选择" style="width: 100%">-->
<!--                <el-option-->
<!--                  v-for="item in company_list"-->
<!--                  :key="item.name"-->
<!--                  :label="item.name"-->
<!--                  :value="item.name">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column
            prop="账龄类型"
            label="账龄类型"
            width="90">
          </el-table-column>
          <el-table-column
            prop="缴费类型"
            label="缴费类型"
            width="90">
          </el-table-column>

<!--          <el-table-column-->
<!--            prop="上次缴费时间"-->
<!--            label="上次缴费时间"-->
<!--            width="170">-->
<!--            <template slot-scope="scope">-->
<!--              <el-link type="primary" size="mini" @click="getLastHouseBill(scope.row)">{{ scope.row['上次缴费时间'] }}</el-link>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            prop="上次缴费时间"
            label="上次缴费时间"
            width="170"></el-table-column>
<!--          <el-table-column-->
<!--            prop="第一次催费时间"-->
<!--            label="第一次催费时间"-->
<!--            width="150">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="第二次催费时间"-->
<!--            label="第二次催费时间"-->
<!--            width="150">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="第三次催费时间"-->
<!--            label="第三次催费时间"-->
<!--            width="150">-->
<!--          </el-table-column>-->
          <el-table-column
            prop="one_gj_time"
            label="第一次催费跟进时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="two_gj_time"
            label="第二次催费跟进时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="three_gj_time"
            label="第三次催费跟进时间"
            width="150">
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="催费次数"-->
<!--            label="催费次数"-->
<!--            width="90">-->
<!--          </el-table-column>-->
          <el-table-column
            prop="cur_month_times"
            label="月催费次数"
            width="90">
          </el-table-column>
          <el-table-column
            prop="cur_year_times"
            label="年催费次数"
            width="90">
          </el-table-column>
          <el-table-column
            prop="欠费类型"
            label="欠费类型"
            width="150">
            <template slot-scope="scope">
              <span v-if="scope.row['欠费类型']">{{scope.row['欠费类型']}}</span>
              <span v-if="scope.row['欠费类型原因']"> ： {{scope.row['欠费类型原因']}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="欠费原因"-->
<!--            label="欠费原因"-->
<!--            width="150">-->
<!--          </el-table-column>-->
          <el-table-column
            prop="业主诉求"
            label="业主诉求"
            width="150">
          </el-table-column>
          <el-table-column
            prop="解决措施"
            label="催费措施"
            width="150">
          </el-table-column>
          <el-table-column
            prop="备注"
            label="备注"
            width="200">
          </el-table-column>
          <el-table-column
            label="审批流程"
            width="200">
            <template slot-scope="scope">
              <el-link v-if="scope.row.one_task_id" type="primary" size="mini" @click="openFlow(scope.row.one_task_id)">审批流程1</el-link>
              <el-link v-if="scope.row.two_task_id" type="primary" size="mini" @click="openFlow(scope.row.two_task_id)">审批流程2</el-link>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100" fixed="right">
            <template slot-scope="scope">
<!--              <el-button type="primary" size="mini" @click="editType(scope.row)">变更催缴</el-button>-->
<!--              <el-link type="primary" @click="openFlow(scope.row)">审批流程</el-link>&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--              <el-button type="danger" size="mini" @click="delHouse(scope.row)">移除</el-button>-->
<!--              <el-button-group>-->
<!--                <el-button type="primary" size="mini" @click="toThirdPartyLitigation2([scope.row['ch_md5']],1)">自催</el-button>-->
<!--                <el-button type="primary" size="mini" v-if="show_btn_type.includes(2)" @click="toThirdPartyLitigation2([scope.row['ch_md5']],2)">诉讼</el-button>-->
<!--                <el-button type="primary" size="mini" v-if="show_btn_type.includes(5)" @click="toThirdPartyLitigation2([scope.row['ch_md5']],5)">项目自催</el-button>-->
<!--                <el-button type="primary" size="mini" v-if="show_btn_type.includes(3)" @click="toThirdPartyLitigation2([scope.row['ch_md5']],3)">第三方管理</el-button>-->
<!--                <el-button type="primary" size="mini" v-if="show_btn_type.includes(4)" @click="toThirdPartyLitigation2([scope.row['ch_md5']],4)">第三方诉讼</el-button>-->
<!--              </el-button-group>-->

              <el-button type="primary" size="mini" @click="$refs.LegalHouseInfo.show({project_house_id:scope.row['项目ID'],house_id:scope.row['房产ID']})">催缴详情</el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="sizes,total,prev, pager, next"
          :total="pageData.total*1"
          :page-size="pageData.pageSize*1"
          :current-page="pageData.page*1"
          @current-change="pageChange"
          @size-change="handleSizeChange"
          :page-sizes="[15,20,50,100, 200, 300, 400,500,1000]"></el-pagination>
      </div>
    </div>
    <el-dialog title="修改催缴类型" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ from_data['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ from_data['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ from_data['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="催缴类型">
            <el-select placeholder="催缴类型" v-model="from_data['催缴类型']">
              <el-option value="自催" label="自催"></el-option>
              <el-option value="诉讼" label="诉讼"></el-option>
              <el-option value="第三方" label="第三方"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="计划催缴月份">
            <el-date-picker
              style="width: 150px"
              v-model="from_data['计划催缴月份']"
              size="mini"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ from_data['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ from_data['欠费类型'] }}</el-descriptions-item>
<!--          <el-descriptions-item label="欠费原因">{{ from_data['欠费原因'] }}</el-descriptions-item>-->
          <el-descriptions-item label="业主诉求">{{ from_data['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="onClose">关 闭</el-button>
          <el-button @click="editTypeSubmit">修 改</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="最后一次缴费明细" :visible.sync="dialogVisible_2" :close-on-click-modal="false" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ house_bill_order_2['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ house_bill_order_2['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ house_bill_order_2['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ house_bill_order_2['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ house_bill_order_2['欠费类型'] }}</el-descriptions-item>
<!--          <el-descriptions-item label="欠费原因">{{ house_bill_order_2['欠费原因'] }}</el-descriptions-item>-->
          <el-descriptions-item label="业主诉求">{{ house_bill_order_2['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="dialogVisible_2=false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>

  </div>
  <ViewFile ref="ViewFile" />
  <ViewFlow ref="viewFlowRef" />
  <LegalHouseInfo ref="LegalHouseInfo" />
  <LegalHouseMoneyList ref="legalHouseMoneyListRef" />
  <UsePlanDialog ref="usePlanDialogRef" />
</div>
</template>

<script>
import Http from "../../common/Http";
import ViewFile from "../../../Common/ViewFile";
import {CommonHelp} from "../../common/CommonHelp";
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";
import moment from "moment";
import AgeTip from "../common/AgeTip";
import LegalHouseInfo from "../LegalHouseInfo";
import LegalHouseMoneyList from "../LegalHouseMoneyList"
import UsePlanDialog from "./UsePlanDialog";
import HeaderTip from "../../../Common/header-tip";

export default {
  name: "LegalHousePlanUnitEditor",
  components: {HeaderTip, UsePlanDialog, LegalHouseMoneyList, LegalHouseInfo, AgeTip, ViewFlow, ViewFile},
  inject:['where','reginWhere'],
  props:{
    urge_type:{
      type:Number,
      default(){
        return 1
      }
    },
    show_btn_type:{
      type:Array,
      default() {
        return [];
      }
    },
    show_select_type:{
      type:Array,
      default() {
        return [];
      }
    },
    header_not_search:{
      type:Array,
      default() {
        return ['p_age']
      }
    },
    showAge:{
      type: Boolean,
      default(){
        return true
      }
    }
  },
  data(){
    return{
      where2:{
        // urge_type:"",
        age:this.urge_type===1?1:"",
        cur_month_times:"",
        cur_year_times:"",
        type:"",
        qf_time:moment().format("YYYY-MM"),
        jh_time:'',//moment().format("YYYY-MM"),
        house_name:"",
        room_status:"",
        arrears_level1:'',
        arrears_level2:'',
        is_use:0,
        gj_time:"",
        month_count:"",
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      from_data:{},
      dialogVisible:false,
      dialogVisible_2:false,
      house_bill_order_2:{},
      multipleSelection:[],
      arrears_arr:[],
      arrears_arr_children:[],
      company_list:[],
      legalHouseCountObj:{
        moneyTypeSumMoney:0,
        use_month_count:0,
        use_yaer_count:0,
      },
    }
  },
  mounted() {
    const that=this;
    that.where2.age = that.urge_type===1?1:"";
    this.pageChange(1);
    this.getArrearsArr();
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_ids":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.age":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    // "where2.urge_type":function (n,o) {
    //   const that=this;
    //   CommonHelp.debounce(function () {
    //     that.pageChange(1);
    //   },500,that);
    // },
    "where2.qf_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.cur_month_times":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.cur_year_times":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.room_status":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level1":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level2":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.jh_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.house_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.is_use":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.gj_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.month_count":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  computed:{
    ch_md5s(){
      return this.multipleSelection.map(ret=>ret.ch_md5)
    },
    ages(){
      if(this.urge_type===1){
        return this.where2.age?this.where2.age:'1,2'
      }else {
        return this.where2.age?this.where2.age:'3,4'
      }
    },
    ages2(){
      if(this.urge_type===1){
        return this.reginWhere.age?this.reginWhere.age:'1,2'
      }else {
        return this.reginWhere.age?this.reginWhere.age:'3,4'
      }
    },
    useYaerRate(){
      return this.pageData.total?(Math.round(this.legalHouseCountObj.use_yaer_count/this.pageData.total*10000)/100):0;
    },
    useMonthRate(){
      return this.pageData.total?(Math.round(this.legalHouseCountObj.use_month_count/this.pageData.total*10000)/100):0;
    }
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        urge_type:that.urge_type,
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }

      ButlerHttp.post("LegalHouse/getLegalHouseList",{
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          res.data.list.map(ret => {

            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            return ret;
          })
          that.pageData = res.data
        }
        that.loading = false;
      });
      (that.pageData.page===1)&&this.getLegalHouseCountObj()
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
    getArrearsArr(){
      const that=this;
      ButlerHttp.get("Legal/getArrearsArr",{},ret=>{
        if(ret.code){
          that.arrears_arr=ret.data;
        }
      })
    },
    handleSizeChange(i){
      this.pageData.pageSize = i;
      this.pageChange(1);
    },
    getLegalHouseCountObj(){
      const that = this;
      let where = {
        urge_type:that.urge_type,
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }

      ButlerHttp.post("LegalHouse/getLegalHouseCountObj",{
        ...where,
      }, res => {
        if (res.code) {
          that.legalHouseCountObj = res.data
        }
      });
    },
    exportExcel(type=1) {
      const that = this;
      console.log(that.reginWhere.project_name)
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      if(type===2){
        where={
          ...where,
          ...that.where2,
          urge_type:that.urge_type,
          area_id:that.reginWhere.area_id
        }
      }
      // let where = {
      //   urge_type:that.urge_type,
      //   ...that.where2,
      //   project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
      //   project_id:that.reginWhere.project_name,
      //   area_id:that.reginWhere.area_id
      // }
      //type===1?"admin/Legal/getLegalHouseExcel2":"admin/Legal/getLegalHouseExcel",
      ButlerHttp.post(type===1?"Legal/getLegalHouseExcel2":"Legal/getLegalHouseExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    importLegalHouseExcel(){
      const that=this;
      Http.uploadFile(file=>{
        const loading=that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("Legal/importLegalHouseToFlow", {
          file: file
        }, res => {
          loading.close();
          if (res.code) {
            let timeStr = new Date().getTime();
            ERP.navigateTo(`/flow/FlowView?sheet_id=140&master_id=114&timeValue=${timeStr}&batch_number=${res.data}`);
            // that.pageChange(1);
          } else {
            that.$message.error(res.msg);
          }
        });
      })
    },
    editType(item){
      const that=this;
      that.from_data=item;
      that.dialogVisible=true;
    },
    onClose(){
      this.dialogVisible=false;
      this.from_data={}
    },
    houseLegalToTempByHouseIds(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ch_md5s.length){
        that.$message.error('请勾选房产！');
        return false
      }
      that.loading = true;
      ButlerHttp.post("LegalHouse/houseLegalToTempByHouseIds",{
        projectId:that.reginWhere.project_name,
        ch_md5s:that.ch_md5s.join(','),
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("操作成功")
          that.$emit("onAdd",{})
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    houseLegalToTemp(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      that.loading = true;
      ButlerHttp.post("LegalHouse/houseLegalToTemp",{
        ...where,
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$emit("onAdd",{})
        }else {
          that.$message.error(res.msg);
        }
      });
    },
    editTypeSubmit(){
      const that=this;
      let urge_type_obj={
        '自催':1,
        '诉讼':2,
        '第三方':3
      }
      ButlerHttp.post("Legal/updateLegalHouseType", {
        id: that.from_data.id,
        ch_md5: that.from_data.ch_md5,
        urge_type: urge_type_obj[that.from_data['催缴类型']],
        year_month: that.from_data['计划催缴月份']
      }, res => {
        if (res.code) {
          that.onClose();
          that.$message.success("操作成功");
          that.pageChange(1);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    getHouseBill(item){
      const that=this;
      that.$refs.legalHouseMoneyListRef.show({
        project_id:item.PrecinctID,
        house_id:item.HouseID,
      })
    },
    getLastHouseBill(item){
      const that=this;
      ButlerHttp.post("Legal/getLastHouseBill", {
        projectId: item['项目ID'],
        houseId: item['房产ID'],
        last_time: item['上次缴费时间']
      }, res => {
        if (res.code) {
          that.dialogVisible_2 = true;
          that.house_bill_order_2 = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    delHouse(item){
      const that=this;
      that.$confirm(`您将要移除该【${item['房产信息']}】欠费房产，移除后将不再显示该房产的欠费计划，包含自催、诉讼和第三方管理。您确定操作吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post("Legal/delHouseUrge", {
          projectId: item['项目ID'],
          ch_md5: item.ch_md5,
        }, res => {
          if (res.code) {
            that.$message.success(res.msg);
            that.getList();
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delHouseIds(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ch_md5s.length){
        that.$message.error('请勾选房产！');
        return false
      }
      that.$confirm(`您将要移除这些欠费房产，移除后将不再显示该房产的欠费计划，包含自催、诉讼和第三方管理。您确定操作吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post("Legal/delHouseUrge", {
          projectId: that.reginWhere.project_name,
          ch_md5s: that.ch_md5s.join(',')
        }, res => {
          if (res.code) {
            that.$message.success(res.msg);
            that.getList();
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },
    openFlow(task_id){
      const that = this;
      if(!task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:task_id})
    },
    exportExcelNote(){
      this.$emit("exportExcelNote",{})
    },
    toThirdPartyLitigation(ch_md5s){
      const that=this;
      that.$confirm(`您将把所选房产转为第三方诉讼。您确定操作吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading = true;
        ButlerHttp.post("HouseUrge/updateUrgeType", {
          ch_md5s: ch_md5s.join(','),
          urge_type: 4,
        }, res => {
          that.loading = false;
          if (res.code) {
            that.pageChange(1)
          } else {
            that.$message.error(res.msg);
          }
        });
      })
    },
    toThirdPartyLitigation2(ch_md5s,urge_type=4){
      const that=this;
      let uge_type_obj={
        1:'自催',
        2:'诉讼',
        5:'项目自催',
        3:'第三方管理',
        4:'第三方诉讼'
      }
      // that.$confirm(`您将把所选房产转为${uge_type_obj[urge_type]}。您确定操作吗？`, '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   that.loading = true;
      //   ButlerHttp.post("LegalHouse/houseLegalToTempByHouseIds", {
      //     project_id: that.reginWhere.project_name,
      //     ch_md5s: ch_md5s.join(','),
      //     urge_type: urge_type,
      //   }, res => {
      //     that.loading = false;
      //     if (res.code) {
      //       // that.pageChange(1)
      //     } else {
      //       that.$message.error(res.msg);
      //     }
      //   });
      // })
      ButlerHttp.post("LegalHouse/houseLegalToTempByHouseIds", {
        project_id: that.reginWhere.project_name,
        ch_md5s: ch_md5s.join(','),
        urge_type: urge_type,
      }, res => {
        if (res.code) {
          that.$message.success(`${ch_md5s.length}个房产已转为${uge_type_obj[urge_type]}`);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    toThirdPartyLitigation3(ch_md5s,urge_type=4){
      const that=this;
      let uge_type_obj={
        1:'自催',
        2:'诉讼',
        5:'项目自催',
        3:'第三方管理',
        4:'第三方诉讼'
      }
      let where = {
        urge_type:that.urge_type,
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      ERP.showLoading();
      ButlerHttp.post("LegalHouse/houseLegalToTempByWhere", {
        ...where,
        ch_md5s: ch_md5s.join(','),
        update_urge_type: urge_type,
      }, res => {
        ERP.hideLoading();
        if (res.code) {
          let txt='';
          if(ch_md5s.length){
            txt=` ${ch_md5s.length} 个房产已转为【${uge_type_obj[urge_type]}】`;
          }else {
            txt=` ${that.pageData.total} 个房产已转为【${uge_type_obj[urge_type]}】`;
          }
          that.$confirm(`您已经选择${txt}，是否前往【${uge_type_obj[urge_type]}】操作发起流程？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            console.log("确定")
            if(urge_type===2){
              // ERP.navigateTo("/Butler/Litigation?tab2=LegalHousePlanTemp"); //诉讼
              that.$router.push({
                name: "Litigation",
                query: {
                  tab2: "LegalHousePlanTemp"
                }
              });
            }else if(urge_type===3){
              // ERP.navigateTo("/Butler/ThirdPartyLegal?tab2=LegalHousePlanTemp"); //第三方管理
              that.$router.push({
                name: "ThirdPartyLegal",
                query: {
                  tab2: "LegalHousePlanTemp"
                }
              });
            }else if(urge_type===4){
              // ERP.navigateTo("/Butler/ThirdPartyLitigation?tab2=LegalHousePlanTemp"); //第三方诉讼
              that.$router.push({
                name: "ThirdPartyLitigation",
                query: {
                  tab2: "LegalHousePlanTemp"
                }
              });
            }else if(urge_type===5){
              // ERP.navigateTo("/Butler/LegalLitigation?tab2=LegalHousePlanTemp"); //项目自催
              that.$router.push({
                name: "LegalLitigation",
                query: {
                  tab2: "LegalHousePlanTemp"
                }
              });
            }else {
              that.$message.error("数据异常");
            }
          }).catch(() => {
            console.log("取消")
          })

        } else {
          that.$message.error(res.msg);
        }
      });
    },
    toThirdPartyLitigation4(ch_md5s,urge_type=4){
      const that=this;
      let uge_type_obj={
        1:'自催',
        2:'诉讼',
        5:'项目自催',
        3:'第三方管理',
        4:'第三方诉讼'
      }
      let where = {
        urge_type:that.urge_type,
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }








      return false
      ERP.showLoading();
      ButlerHttp.post("LegalHouse/houseLegalToTempByWhere", {
        ...where,
        ch_md5s: ch_md5s.join(','),
        update_urge_type: urge_type,
      }, res => {
        ERP.hideLoading();
        if (res.code) {
          let txt='';
          if(ch_md5s.length){
            txt=` ${ch_md5s.length} 个房产已转为【${uge_type_obj[urge_type]}】`;
          }else {
            txt=` ${that.pageData.total} 个房产已转为【${uge_type_obj[urge_type]}】`;
          }


        } else {
          that.$message.error(res.msg);
        }
      });
    },
    toThirdPartyLitigations(urge_type=4){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      // if(!that.ch_md5s.length){
      //   that.$message.error('请勾选房产！');
      //   return false
      // }
      // that.toThirdPartyLitigation3(that.ch_md5s,urge_type)

      if(that.multipleSelection.length===0){
        that.$message.error("请选择欠费房产");
        return ;
      }
      that.$refs.usePlanDialogRef.show({
        type_id:that.reginWhere.type_id,
        project_id:that.reginWhere.project_name,
        house_list:that.multipleSelection,
        urge_type:urge_type,
        yearmonth:moment().format("YYYY-MM")
      },()=>{
        that.getList();
      })
    },
    changeArrearsLevel1(id){
      const that=this;
      let arrears_index=that.arrears_arr.findIndex(ret=>ret.id===id)
      if(arrears_index!==-1){
        that.arrears_arr_children=that.arrears_arr[arrears_index].children||[];
        that.where2.arrears_level2='';
      }else {
        that.arrears_arr_children=[];
        that.where2.arrears_level2='';
      }
    },
    toRound(val,num=2){
      return Math.round(val*Math.pow(10,num))/Math.pow(10,num)
    },
    // 录入法务案件
    exportThirdPartyExcel(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        urge_type:that.urge_type,
        ...that.where2,
      }
      let urlObj={
        2:"Litigation/exportExcel",
        3:"ThirdPartyLegal/exportExcel",
        4:"ThirdPartyLitigation/exportExcel"
      }
      if(!urlObj[that.urge_type]){
        that.$message.error("计划催缴类型异常无法导出");
        return false
      }
      ButlerHttp.post(urlObj[that.urge_type], {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    getAllOfIdAndName(){
      const that=this;
      ButlerHttp.get("ProjectCollectionThridCompany/getAllOfIdAndName",{}, res => {
        if (res.code) {
          that.company_list=res.data
        }
      });
    },

  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }

  .el-button+ .el-button {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LegalHousePlanUnitEditor.vue